import { defineComponent as n, createBlock as t, openBlock as r, unref as c, mergeProps as p, withCtx as i, createElementVNode as l } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
import { useComponentDeprecation as s } from "../../composables/useComponentDeprecation.js";
const C = /* @__PURE__ */ n({
  name: "IconAi",
  __name: "IconAi",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(a) {
    const o = a;
    return s({
      deadline: "2025-06-23T00:00:00.000Z",
      reason: "Deprecated ‘AI’ to rename it to ‘Sparkles’ (new icon)",
      replacementName: "Sparkles"
    }), (A, e) => (r(), t(c(m), p(o, { "view-box": "0 0 24 24" }), {
      default: i(() => [...e[0] || (e[0] = [
        l("path", {
          "fill-rule": "evenodd",
          d: "M7.5 2.25A.75.75 0 0 1 8.25 3c0 1.506.324 2.389.85 2.911C9.627 6.435 10.51 6.75 12 6.75a.75.75 0 0 1 0 1.5c-1.483 0-2.37.323-2.898.852C8.572 9.63 8.25 10.517 8.25 12a.75.75 0 0 1-1.5 0c0-1.482-.325-2.369-.855-2.898C5.365 8.572 4.478 8.25 3 8.25a.75.75 0 0 1 0-1.5c1.483 0 2.369-.315 2.897-.84C6.424 5.389 6.75 4.505 6.75 3A.75.75 0 0 1 7.5 2.25M7.499 6.287a3.7 3.7 0 0 1-1.222 1.218A3.737 3.737 0 0 1 7.499 8.73a3.73 3.73 0 0 1 1.22-1.225A3.695 3.695 0 0 1 7.5 6.287M15 8.25A.75.75 0 0 1 15.75 9c0 1.884.47 3.16 1.28 3.97s2.086 1.28 3.97 1.28a.75.75 0 0 1 0 1.5c-1.884 0-3.16.47-3.97 1.28s-1.28 2.086-1.28 3.97a.75.75 0 0 1-1.5 0c0-1.884-.47-3.16-1.28-3.97S10.884 15.75 9 15.75a.75.75 0 0 1 0-1.5c1.884 0 3.16-.47 3.97-1.28s1.28-2.086 1.28-3.97A.75.75 0 0 1 15 8.25m0 4.428a5.189 5.189 0 0 1-.97 1.352A5.189 5.189 0 0 1 12.678 15a5.189 5.189 0 0 1 1.352.97A5.189 5.189 0 0 1 15 17.322a5.189 5.189 0 0 1 .97-1.352A5.189 5.189 0 0 1 17.322 15a5.189 5.189 0 0 1-1.352-.97A5.189 5.189 0 0 1 15 12.678",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  C as default
};
